import A from './A';
import B from './B';

export default function Step2({ calcObj, callback }: any) {
    const { check1 } = calcObj;
    return (
        <div className={`dpu-calculator-step2`}>
            {check1 === 1 && <A calcObj={calcObj} callback={callback} />}
            {check1 === 2 && <B calcObj={calcObj} callback={callback} />}
        </div>
    );
}
